import {
  AddressAutocompletePlaceField,
  AddressAutocompletePrimaryType
} from "../interfaces/googlePlaces.interface";
import { SelectOption } from "../interfaces/form.interface";

export const DEFAULT_TEXT_MINIMUM_LENGTH = 4;
export const DEFAULT_TEXT_MAXIMUM_LENGTH = 99;
export const NAME_MAXIMUM_LENGTH = 100;
export const BEHALF_OF_NOTE_LENGTH = 120;
export const ADDRESS_LINE_MAXIMUM_LENGTH = 255;
export const SUBURB_MAXIMUM_LENGTH = 26;
export const EMAIL_MAXIMUM_LENGTH = 255;
export const PASSWORD_MINIMUM_LENGTH = 8;
export const PASSWORD_MAXIMUM_LENGTH = 256;
export const VERIFICATION_CODE_LENGTH = 6;
export const PHONE_MINIMUM_LENGTH = 7;
export const PHONE_MAXIMUM_LENGTH = 15;
export const DISCOVERY_FEEDBACK_LENGTH = 255;
export const INVALID_AUSTRALIAN_NUMBER_ERROR_MESSAGE =
  "Please enter a valid Australian mobile number. Must be in this format: 04xxxxxxxx.";
export const INVALID_POSTCODE_ERROR_MESSAGE = "Please enter a valid Australian postcode.";
export const INVALID_FIRST_NAME_ERROR_MESSAGE = "Please enter a valid first name.";
export const INVALID_LAST_NAME_ERROR_MESSAGE = "Please enter a valid last name.";
export const NEED_RESET_PASSWORD_MESSAGE =
  "For security reasons, you need to reset your password before signing in. Confirm your email below to receive a code.";
export const UNEXPECTED_ERROR_MESSAGE =
  "Sign in failed. Please try again or contact support if the problem persists.";

export const FIRST_NAME_REGEX = /^[\p{L}\p{M}][\p{L}\p{M}\s'.-]*$/u;
export const LAST_NAME_REGEX = /^[\p{L}\p{M}][\p{L}\p{M}\s'.-]*$/u;

export const LOCAL_AUSTRALIAN_NUMBER_REGEX =
  /^04([0-9]{2}\s?)([0-9]{3}\s?[0-9]{3}|[0-9]{2}\s?[0-9]{2}\s?[0-9]{2})$/;

export const INTL_AUSTRALIAN_NUMBER_REGEX =
  /^\+614([0-9]{2}\s?)([0-9]{3}\s?[0-9]{3}|[0-9]{2}\s?[0-9]{2}\s?[0-9]{2})$/;

export const EMAIL_REGEX = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ ^$*.[\]{}()?"!@#%&/\\,><':;|_~`+=-]).+$/;

export const AUSTRALIAN_POSTCODE_REGEX = /^0[289][0-9]{2}$|^[1-9][0-9]{3}$/;

export const DEFAULT_COUNTRY_CODE = "AU";

export const ADDRESS_AUTOCOMPLETE_MINIMUM_INPUT_LENGTH = 3;
export const ADDRESS_AUTOCOMPLETE_DEBOUNCE_MILLISECONDS = 300;
export const ADDRESS_AUTOCOMPLETE_REGION_CODE = "au";
export const ADDRESS_AUTOCOMPLETE_PRIMARY_TYPES: AddressAutocompletePrimaryType[] = [
  "street_address",
  "premise",
  "subpremise"
];
export const ADDRESS_AUTOCOMPLETE_PLACE_FIELDS: AddressAutocompletePlaceField[] = [
  "addressComponents"
];

export const minimumLengthMessage = (minimumLength: number): string =>
  `Must be greater than ${minimumLength - 1} characters`;

export const maximumLengthMessage = (maximumLength: number): string =>
  `Must be less than ${maximumLength + 1} characters`;

export const defaultSelectOption: SelectOption[] = [
  {
    label: "-- Please select --",
    value: "",
    isDefault: true
  }
];

export enum ZohoCustomFields {
  ZAKAT_QA_SUBMISSION = "Zakat QA Submission",
  NEWSLETTER_SUBSCRIBED = "Newsletter Subscribed",
  RAMADAN_CALENDAR_LEAD = "Ramadan Calendar Lead",
  RETHINK_ZAKAT_LANDING_PAGE = "Rethink Zakat LP Subscribed",
  GAZA_ASSISTANCE_LANDING_PAGE = "Gaza Assistance LP Subscribed",
  MISSED_ZAKAT_LANDING_PAGE = "Missed Zakat LP Subscribed",
  DONOR = "Donor",
  USER_ACCOUNT = "User Account",
  CALCULATED_ZAKAT = "Calculated Zakat"
}
